<template>
    <div class="h5bg" style="position:relative;">
        <div style="height: 10px;"></div>
        <div style="padding:20px;background-color: #fff; margin:0 10px; border-radius: 6px;">
            <el-form ref="form" :model="enterInfo" label-position="top" label-width="180px">
                <el-form-item label="联系人" style="margin-bottom: 0;" required>
                    <el-input v-model="enterInfo.linkman" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" style="margin-bottom: 0;" required>
                    <el-input type="number" v-model="enterInfo.tel" placeholder="请输入联系人电话,请输入数字"></el-input>
                </el-form-item>

                <el-form-item label="预约项目" style="margin-bottom: 0;" required>
                    <el-select v-model="enterInfo.project_id" placeholder="请选择体育项目" style="width:100%">
                        <el-option v-for="(item, index) in projectList" :label="item.project_name"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item v-if="type != 3" :label="type == 1 ? '预约场馆' : type == 2 ? '预约场地' : ''"
                    style="margin-bottom: 0;" required>
                    <el-select v-model="enterInfo.table_id" placeholder="请选择" style="width:100%">
                        <el-option v-for="(item, index) in cgList" :label="item.venue_name"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="type == 3" label="预约课程" style="margin-bottom: 0;" required>
                    <el-select v-model="enterInfo.table_id" placeholder="请选择" style="width:100%" @change="handleChange">
                        <el-option v-for="(item, index) in courseList" :label="item.project_name"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="type != 3" label="预约教练" style="margin-bottom: 0;">
                    <el-select v-model="enterInfo.teacher_id" placeholder="请选择教练" style="width:100%">
                        <el-option v-for="(item, index) in teacherList" :label="item.username"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="type == 3 && enterInfo.teacher_name" label="预约教练" style="margin-bottom: 0;">
                    <el-input disabled v-model="enterInfo.teacher_name"></el-input>
                </el-form-item>
                <el-form-item label="预约日期" style="margin-bottom: 0;" required>
                    <el-date-picker size="small" v-model="enterInfo.reserve_date" align="right" type="date"
                        placeholder="选择日期" value-format="yyyy-MM-dd" style="width:300px;">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="预约时间" style="margin-bottom: 0;" required>
                    <el-time-select placeholder="起始时间" v-model="enterInfo.start_time" :picker-options="{
                        start: '08:30',
                        step: '00:10',
                        end: '18:30'
                    }">
                    </el-time-select>
                    <el-time-select placeholder="结束时间" v-model="enterInfo.end_time" :picker-options="{
                        start: '08:30',
                        step: '00:10',
                        end: '18:30',
                        minTime: enterInfo.$messagestartTime
                    }">
                    </el-time-select>

                </el-form-item>

                <el-form-item label="备注" style="margin-bottom: 0;" required>
                    <el-input v-model="enterInfo.remark" placeholder="备注"></el-input>
                </el-form-item>



                <!-- openid&pmid&type
                {{ openid }}
                {{ pmid }}
                {{ type }} -->

                <div>
                    <el-button v-if="!loading" type="primary" @click="saveForm" :loading="loading"
                        style="width: 100%; margin-top: 50px; margin-bottom: 50px;">提交预约</el-button>
                </div>


            </el-form>


        </div>

        <div style="position:absolute;top:10px;right:10px;">
            <el-button type="primary" @click="goPage" size="mini" style="">查看我的预约</el-button>
        </div>
        <div style="height:20px"></div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            openid: "",
            pmid: 0,
            type: 1,
            loading: false,

            enterInfo: {
                firm_name: "",
                firm_num: "",
                address: "",
                firm_principal: "",
                tel: "",
                pjson: {
                    xjh: ""
                },
            },
            zphid: 0,
            job_info_list: [],
            job: { "post": "", "num": 3, boy: "", girl: "", "specialty": "", "culture": "", "foreignLanguage": "", "computer": "", jintie: "", salary: "" },
            fileList: [],
            cgList: [],
            teacherList: [],
            courseList: [],
            projectList:[]
        };
    },
    mounted() {
        let aa = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx35fabc32ee24a50d&redirect_uri=http%3A%2F%2Fwxh5.aiwx.org.cn%2Fcode%3Fq%3D1%26uri%3Dhttps%253A%252F%252Fsx.qushixi.org.cn%252Fzhaopin%252F%2523%252Fzpdj%253Fpmid%253D1&response_type=code&scope=snsapi_base#wechat_redirect'
        // console.log(aa)
        // console.log(276, decodeURIComponent('http%3A%2F%2Fwxh5.aiwx.org.cn%2Fcode%3Fq%3D1%26uri%3D'))
        // console.log(277, decodeURIComponent('https%3A%2F%2Fsx.qushixi.org.cn%2Fzhaopin%2F%23%2Fzpdj%3Fpmid%3D219'))
        // http://wxh5.aiwx.org.cn/code?q=1&uri=https://sx.qushixi.org.cn/#/h5_reserve_cg?pmid=1



        let bb = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx35fabc32ee24a50d&redirect_uri=http://wxh5.aiwx.org.cn/code?q=1&uri=http://njxwzz.aiwx.org.cn/zhty/#/h5_reserve_cg?pmid=1&response_type=code&scope=snsapi_base#wechat_redirect'


        let cc = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx35fabc32ee24a50d&redirect_uri=http%3A%2F%2Fwxh5.aiwx.org.cn%2Fcode%3Fq%3D1%26uri%3Dhttp%253A%252F%252Fnjxwzz.aiwx.org.cn%252Fzhty%252F%2523%252Fh5_reserve_cg%253Fpmid%253D219&response_type=code&scope=snsapi_base#wechat_redirect'
        // http://njxwzz.aiwx.org.cn/zhty/#/h5_reserve_cg

        let dd = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx35fabc32ee24a50d&redirect_uri=http%3A%2F%2Fwxh5.aiwx.org.cn%2Fcode%3Fq%3D1%26uri%3Dhttp%253A%252F%252Fnjxwzz.aiwx.org.cn%252Fzhty%252F%2523%252Fh5_reserve_cg%253Fpmid%253D1%2526type%253D1&response_type=code&scope=snsapi_base#wechat_redirect'
        let dd2 = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx35fabc32ee24a50d&redirect_uri=http%3A%2F%2Fwxh5.aiwx.org.cn%2Fcode%3Fq%3D1%26uri%3Dhttp%253A%252F%252Fnjxwzz.aiwx.org.cn%252Fzhty%252F%2523%252Fh5_reserve_cg%253Fpmid%253D1%2526type%253D2&response_type=code&scope=snsapi_base#wechat_redirect'
        let dd3 = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx35fabc32ee24a50d&redirect_uri=http%3A%2F%2Fwxh5.aiwx.org.cn%2Fcode%3Fq%3D1%26uri%3Dhttp%253A%252F%252Fnjxwzz.aiwx.org.cn%252Fzhty%252F%2523%252Fh5_reserve_cg%253Fpmid%253D1%2526type%253D3&response_type=code&scope=snsapi_base#wechat_redirect'
        console.log(dd)

        let _this = this

        this.openid = this.$route.query.openid
        this.pmid = this.$route.query.pmid
        this.type = this.$route.query.type || 1
        sessionStorage.setItem("openid", this.$route.query.openid);
        sessionStorage.setItem("pmid", this.$route.query.pmid);
        sessionStorage.setItem("type", this.type);

       
        document.title = "场馆预约"
        if (this.type == 2) {
            document.title = "场地预约"
        }
        if (this.type == 3) {
            document.title = "课程预约"
        }
        this.$nextTick(() => {
            _this.$forceUpdate()
        })
        this.getParams()
        // this.getList()

    },
    methods: {
        getParams() {
            

            this.$http.post("/api/sport_project_list", { type: this.type, pagesize: 9999 }).then(res => {
                if (res.data.data) {
                    this.projectList = res.data.data
                }
                console.log(106, this.cgList)

            })
            if (this.type != 3) {

                this.$http.post("/api/venue_list", { type: this.type, pagesize: 9999 }).then(res => {
                    if (res.data.data) {
                        this.cgList = res.data.data
                    }
                    console.log(106, this.cgList)

                })
                this.$http.post("/api/t_sch_teachers_list", { pagesize: 9999 }).then(res => {
                    if (res.data.data) {
                        this.teacherList = res.data.data
                    }
                    console.log(106, this.teacherList)

                })
            } else {
                this.$http.post("/api/lesson_list", { pagesize: 9999 }).then(res => {
                    if (res.data.data) {
                        this.courseList = res.data.data
                    }
                    console.log(106, this.courseList)

                })
            }
        },

        handleChange(e) {
            this.courseList.map(a => {
                if (a.id == e) {
                    this.enterInfo.teacher_id = a.teacher_id
                    this.enterInfo.teacher_name = a.teacher_name
                }
            })
        },
        getList() {
            this.$http.post("/api/get_enter_info_byopenid", { pmid: this.pmid, openid: this.openid }).then(res => {
                if (res.data) {
                    let enterInfo = res.data
                    if (res.data.zph) {
                        this.job_info_list = JSON.parse(res.data.zph.job_info_list)
                        enterInfo.pjson = JSON.parse(res.data.zph.pjson)
                        this.zphid = res.data.zph.id
                    } else {
                        this.job_info_list = [{ ...this.job }]
                        enterInfo.pjson = {
                            xjh: ""
                        }
                    }
                    if (res.data.files) {
                        this.fileList = JSON.parse(res.data.files)
                    }
                    this.enterInfo = enterInfo

                } else {
                    this.job_info_list = [{ ...this.job }]

                }
            })
        },
        addJob() {
            this.job_info_list.push({ ...this.job })
            this.$nextTick(e => {
                $(".h5bg").scrollTop(99999)
            })
        },
        removeJob(i) {
            this.job_info_list.splice(i, 1)
        },

        uploadFiles(e) {
            this.fileList.push(e)
        },
        removeImg(idx) {
            this.fileList.splice(idx, 1)
        },
        checkEnterSuccess() {

        },

        saveForm() {
            if (!this.enterInfo.linkman.trim()) {
                this.$message({ message: "请输入联系人姓名", type: 'error', customClass: "toast", duration: 2000 });
                return
            }

            if (!this.enterInfo.tel.trim()) {
                this.$message({ message: "请输入联系人电话", type: 'error', customClass: "toast", duration: 2000 });
                return
            } else {
                let myreg = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
                if (!myreg.test(this.enterInfo.tel)) {
                    this.$message({ message: "请输入正确的手机号", type: 'error', customClass: "toast", duration: 2000 });
                    return;
                }
            }
            if (!this.enterInfo.project_id) {
                this.$message({ message: "请选择体育项目", type: 'error', customClass: "toast", duration: 2000 });
                return
            }
            if (!this.enterInfo.table_id) {
                this.$message({ message: "请选择场馆", type: 'error', customClass: "toast", duration: 2000 });
                return
            }
            if (!this.enterInfo.teacher_id) {
                this.$message({ message: "请选择教练", type: 'error', customClass: "toast", duration: 2000 });
                return
            }
            if (!this.enterInfo.reserve_date) {
                this.$message({ message: "请选择日期", type: 'error', customClass: "toast", duration: 2000 });
                return
            }
            if (!this.enterInfo.start_time) {
                this.$message({ message: "请选择预约起始时间", type: 'error', customClass: "toast", duration: 2000 });
                return
            }
            if (!this.enterInfo.end_time) {
                this.$message({ message: "请选择预约结束时间", type: 'error', customClass: "toast", duration: 2000 });
                return
            }

           
            this.loading = true
            let data = { ...this.enterInfo }
            data.openid = this.openid
            data.pmid = this.pmid
            data.reserve_type = this.type
            this.$http.post("/api/reverse_edit", data).then(res => {
                this.$message({
                    message: "预约成功！",
                    type: 'success',
                    customClass: "toast",
                    duration: 5000
                });
                this.loading = false
                this.goPage()
            })
        },
        goPage() {
            this.$router.push("/h5_reserve_list?openid=" + this.openid + "&pmid=" + this.pmid + "&type=" + this.type) 
        },

    }

};
</script>

<style scoped>
.h5bg {
    background-image: url(../../../public/img/xiantiao.jpg);
    background-size:cover;
    background-repeat: no-repeat;
    height: 100vh;
    overflow: auto;

}

.remove {
    width: 30px;
    height: 30px;
    position: absolute;
    top: -10px;
    right: -10px;
    background-color: #fff;
    border-radius: 50%;
    overflow: hidden;
}

.remove img {
    width: 100%;
    height: 100%;
}

.add {
    width: 40px;
    height: 40px;
    margin: 0 auto;
}

.add img {
    width: 100%;
    height: 100%;
}
</style>

<style>
.el-form--label-top .el-form-item__label {
    margin-bottom: 0;
    padding: 0;
}

.toast {
    width: 80%;
    min-width: 10% !important;
    max-width: 350px !important;
}

.imgaddbtn {
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    border: 1px dotted #ccc;
    font-size: 30px;
    cursor: pointer;
}

.imgremove {
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;

    cursor: pointer;
    position: absolute;
    top: -5px;
    right: -5px;
    color: #ccc;
}

.imgremove:hover {
    color: orange;
}
</style>